import {
  Home24Regular,
  Home24Filled,
  PanelLeft24Regular,
  PanelLeftExpand24Regular,
  Chat24Regular,
  Chat24Filled,
  DocumentBulletList24Regular,
  DataBarVertical24Regular,
  Shield24Regular,
  Headset24Regular,
  ArrowTrending24Regular,
  Money24Regular,
  DocumentText24Regular,
  ChatMultiple24Regular,
  Apps24Regular,
  QuestionCircle24Regular,
} from "@fluentui/react-icons";
import { useShell } from "../../context/ShellContext";
import { useNavigate, useLocation } from "react-router-dom";
import "./IconNav.css";

const agentIconMap: Record<string, React.ReactElement> = {
  Chat: <Chat24Regular />,
  ChatFilled: <Chat24Filled />,
  DocumentBulletList: <DocumentBulletList24Regular />,
  DataBarVertical: <DataBarVertical24Regular />,
  Shield: <Shield24Regular />,
  Headset: <Headset24Regular />,
  TrendingUp: <ArrowTrending24Regular />,
  Money: <Money24Regular />,
  DocumentText: <DocumentText24Regular />,
};

export function IconNav() {
  const { sidebarOpen, setSidebarOpen, chatHistory, currentConversationId, canManagePrompts } = useShell();
  const navigate = useNavigate();
  const location = useLocation();

  const isTemplates = location.pathname === "/templates";
  const isAgentsStore = location.pathname === "/agents";
  const isAgentRoute = location.pathname.startsWith("/agent/");
  const isInChat = location.pathname === "/" && (currentConversationId != null || new URLSearchParams(location.search).get("chat") != null);
  const isHome = location.pathname === "/" && !isInChat;

  return (
    <nav className="icon-nav" aria-label="Main navigation" data-tour="icon-nav">
      <div className="icon-nav-top">
        {/* Home */}
        <button
          className={`icon-nav-btn ${isHome ? "active" : ""}`}
          data-tour="home-btn"
          title="Home"
          aria-label="Home"
          onClick={() => navigate("/")}
        >
          {isHome ? <Home24Filled /> : <Home24Regular />}
        </button>

        <div className="icon-nav-divider" />

        {/* Agent Store icon */}
        {!sidebarOpen && (
          <button
            className={`icon-nav-btn ${isAgentsStore ? "active" : ""}`}
            data-tour="agent-store"
            title="Agent Store"
            aria-label="Agent Store"
            onClick={() => navigate("/agents")}
          >
            <Apps24Regular />
          </button>
        )}

        {/* Chats summary icon when sidebar is collapsed */}
        {!sidebarOpen && chatHistory.length > 0 && (
          <button
            className={`icon-nav-btn ${isInChat ? "active" : ""}`}
            title={`Chats (${chatHistory.length})`}
            aria-label={`Chats (${chatHistory.length})`}
            onClick={() => setSidebarOpen(true)}
          >
            <ChatMultiple24Regular />
          </button>
        )}
      </div>

      <div className="icon-nav-bottom">
        {/* Help */}
        <button
          className={`icon-nav-btn ${location.pathname === "/help" ? "active" : ""}`}
          data-tour="help-btn"
          title="Help & Manual"
          aria-label="Help & Manual"
          onClick={() => navigate("/help")}
        >
          <QuestionCircle24Regular />
        </button>

        {/* Sidebar toggle */}
        <button
          className="icon-nav-btn"
          title={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
          aria-label={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          {sidebarOpen ? <PanelLeft24Regular /> : <PanelLeftExpand24Regular />}
        </button>
      </div>
    </nav>
  );
}
